import { render, staticRenderFns } from "./TheVoiceBot.vue?vue&type=template&id=87879690&"
import script from "./TheVoiceBot.vue?vue&type=script&lang=js&"
export * from "./TheVoiceBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports